import { render, staticRenderFns } from "./TrackAndTrace.vue?vue&type=template&id=b298da66&scoped=true&"
import script from "./TrackAndTrace.vue?vue&type=script&lang=js&"
export * from "./TrackAndTrace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b298da66",
  null
  
)

export default component.exports